import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import trackerItemText from './trackerItemText';
import {
  convertDateTimeToDate, navigateToUrl,
  replaceVariablesInBrackets
} from '../../../../../../utilities/StringHelpers/StringHelpers';
import './tracker.scss';
import Config from '../../../../../../Config';
import { prepareUrl } from '../../../../../../utilities/StringHelpers/StringHelpers';
import { insertClickToReport } from './DWHReports';
import { getSubscriberDetails, setRetainSubscriberOnLoad } from '../../../SelfCareSlice'
import { useDispatch, useSelector } from 'react-redux';
import { dwhViewAbroadAlert } from '../dwhReports';
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import { getMarketCode } from '../../../../../../utilities/domain/domainConstants';

const marketCode = getMarketCode().toLowerCase();
const purpleArrow = require('./images/chevron Careers Portal.svg');
const purple_bell_gif = require(`./images/bell-${marketCode}.gif`);
const exclamation_mark_gif = require(`./images/Exclamation_Mark_purple-${marketCode}.gif`);
const couponImage = require('./images/coupon.svg');

var text = trackerItemText;

const ArrowCircle = (props) => {
  return (
    <>{isMobile ?
      <></>
      : <Image className='purple-open-arrow'
        src={purpleArrow}
        style={props.isOpen ? { transform: 'rotate(180deg)' } : { transform: 'rotate(0deg)' }} />
    }
    </>
  );
};

function getDayOfWeek(dateString) {
  if (dateString) {
    const [day, month, year] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    const daysOfWeek = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
    return daysOfWeek[date.getDay()];
  }
}

export const AbroadPackageItemExpanded = (props) => {
  const dispatch = useDispatch();
  const abroadPackage = props.abroadPackage;
  const socEffDate = abroadPackage.socEffactiveDate;
  const socExpDate = abroadPackage.socExpDate;
  const mobile = props.subscriberNumber;
  const title = 'התחלת לארוז? יש לך חבילת חו"ל';
  let itemText = text.body.abroadPackage;
  let isOpen = props.currOpenItem === props.id;
  function renderDates(effDate, expDate) {
    if (expDate == '01/01/2001' || expDate == '01.01.2001' || expDate == null) {
      return `${effDate}`;
    } else {
      return `מ ${effDate} עד ${expDate}`;
    }
  }

  const goTo = async (subscriberNumber) => {
    dwhViewAbroadAlert(subscriberNumber,null,null,null,null,null,props.id,null,null,null)
    await dispatch(setRetainSubscriberOnLoad(true));
    await dispatch(getSubscriberDetails(subscriberNumber));
    props.handleCloseTracker();
    prepareUrl(props.urlToAbroad, props.context);
  }

  const propsExtended = { ...props, renderDates };

  return (
    <div
      className={isOpen ? 'tracker-item-expanded tracker-item-expanded-open' : 'tracker-item-expanded'}
      onClick={() => props.handleItemState(props.id)}>
      <div className='tracker-title-and-subtitle'>
        <div className='item-expanded-title'>{replaceVariablesInBrackets(itemText.title.value, mobile, socEffDate, socExpDate)}</div>
        <div className='tracker-subtitle'>
          {isOpen && (
            <><p className={isOpen ? '' : 'tracker-line-elipsis'}>
              לנייד {mobile} יש חבילת חו"ל בתוקף החל {renderDates(socEffDate, socExpDate)}
            </p>
              <div className='tracker-popup-actions'>
                <button className='tracker-popup-action' onClick={() => goTo(props.subscriberNumber)}>
                  עבור לחבילה שלי
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <ArrowCircle isOpen={isOpen} />
    </div>
  );
};

export const ManagerCallItemExpanded = (props) => {
  let itemText = text.body.waitingForCall;
  let title = itemText.title.value;
  let date = props.callDate;
  let isOpen = props.currOpenItem === props.id;
  let actions = {};

  const event = {
    start: props.addToCalendar,
    duration: props.duration,
    title: itemText.title.value,
    description: `שיחה חוזרת משירות ${window.Config.brand_Name_HE}`,
    location: '',
    status: 'CONFIRMED',
    busyStatus: 'BUSY',
  };

  actions['addToCalendar'] = {
    val: itemText.actions.addToCalendar.value,
    url: event,
  };

  actions['deleteMessage'] = props.canCancel === true ? { val: itemText.actions.deleteMessage.value, url: cancelUrl } : { val: false };

  return (
    <div
      className={isOpen ? 'tracker-item-expanded tracker-item-expanded-open' : 'tracker-item-expanded'}
      onClick={() => props.handleItemState(props.id)}>
      <div className='tracker-title-and-subtitle'>
        <div className='item-expanded-title'>{title}</div>
        {isOpen && (
          <div className='tracker-subtitle'>
            {replaceVariablesInBrackets(itemText.text.value, date)
              .split('\n')
              .map((str, i) => (
                <p key={i}>{str}</p>
              ))}
          </div>
        )}
      </div>
      {isOpen && (
        <div className='tracker-popup-actions'>
          {Object.entries(actions).map((el, i) => {
            if (el[1].val) {
              return (
                <button className='tracker-popup-action' key={i} onClick={() => props.openUrl(el[1])}>
                  {el[1].val}
                </button>
              );
            }
          })}
        </div>
      )}
      <ArrowCircle isOpen={isOpen} />
    </div>
  );
};

export const TechnicianVisitItemExpanded = (props) => {
  let cancelUrl = props.URLs.technicianVisitCancel.value;
  let updateUrl = props.URLs.technicianVisitUpdate.value;
  let itemText = text.body.technicianVisit;
  let type = `${window.Config.brand_Name_HE}`;
  if (props.isInfrastructure) {
    type = 'תשתית';
  }
  if (props.isFiber) {
    type = 'פייבר';
  }
  let title = replaceVariablesInBrackets(itemText.title.value, type);
  let desc = replaceVariablesInBrackets(itemText.text.value, type)
    .split('\n')
    .map((str, i) => <p key={i}>{str}</p>);
  let dateTime = replaceVariablesInBrackets(itemText.dateTime.value, props.visitEndTime, props.visitStartTime, props.visitDate);
  let address = props.address ? replaceVariablesInBrackets(itemText.address.value, props.address) : null;
  let specialText = itemText.specialText.value;
  let isOpen = props.currOpenItem === props.id;
  let actions = {};
  let dayName = getDayOfWeek(props.visitDate);

  const event = {
    start: props.addToCalendar,
    duration: props.duration,
    title: title,
    description: '',
    location: address,
    status: 'CONFIRMED',
    busyStatus: 'BUSY',
  };

  actions['addToCalendar'] = {
    val: itemText.actions.addToCalendar.value,
    url: event,
  };

  actions['editVisit'] = props.canEdit === true ? { val: itemText.actions.editVisit.value, url: updateUrl } : { val: false };

  actions['deleteMessage'] = props.canCancel === true ? { val: itemText.actions.deleteMessage.value, url: cancelUrl } : { val: false };
  return (
    <div
      className={isOpen ? 'tracker-item-expanded tracker-item-expanded-open' : 'tracker-item-expanded'}
      onClick={() => props.handleItemState(props.id)}>
      {!isOpen ? (
        <div className='tracker-title-and-subtitle'>
          <div className='item-expanded-title'>{title}</div>
          <div className='tracker-subtitle tracker-line-elipsis'>
            {`נגיע אליך כבר ביום ${dayName} ה- ${props.visitDate} בין השעות ${props.visitStartTime} - ${props.visitEndTime}`}
          </div>
        </div>
      ) : (
        <div
          className='tracker-popup-info'
          onClick={() => props.handleItemState(props.id)}>
          <div className='tracker-title-and-subtitle'>
            <div className='item-expanded-title'>{title}</div>
            {address && (
              <div
                className='tracker-subtitle'>{itemText.addressText.value + ' ' + address}
              </div>
            )}
            <div className='tracker-subtitle'>{`יום ${dayName} ה- ${props.visitDate}`}</div>
            <div className='tracker-subtitle'>{`בין השעות ${props.visitStartTime} - ${props.visitEndTime}`}</div>
            <div className='tracker-subtitle'>{specialText}</div>
            {<div className='tracker-popup-actions'>
              {Object.entries(actions).map((el, i) => {
                if (el[1].val) {
                  return (
                    <button className='tracker-popup-action' key={i} onClick={() => props.openUrl(el[1])}>
                      {el[1].val}
                    </button>
                  );
                }
              })}
            </div>}
          </div>
        </div>
      )}
      <ArrowCircle isOpen={isOpen} />
    </div>
  );
};

export const AbroadInsuranceItemExpanded = (props) => {
  let title = 'יש לך ביטוח נסיעות לחו"ל';
  let dueDate = props.dueDate == null ? '' : props.dueDate.slice(6, 8) + '.' + props.dueDate.slice(4, 6) + '.' + props.dueDate.slice(0, 4);
  let isOpen = props.currOpenItem === props.id;

  return (
    <div className={isOpen ? 'tracker-item tracker-item-expanded-open' : 'tracker-item'}
      onClick={() => props.handleItemState(props.id)}>
      <div className='tracker-title-and-subtitle'>
        <div className='item-expanded-title'>{title}</div>
        {isOpen && (<>
          <div className='tracker-subtitle'>
            <p>
              <span>למנוי</span>
              <span>&nbsp;</span>
              <span>{props.subscriber}</span>
              <span>&nbsp;</span>
              <span>קיים ביטוח נסיעה לחו"ל עד</span>
              <span>&nbsp;</span>
              <span>{dueDate}</span>
              <span>נסיעה בטוחה. </span>
            </p>
          </div>
          <div className='tracker-popup-actions'>
            <button className='tracker-popup-action' onClick={() => { props.setCurrentSubscriber(props.subscriber), prepareUrl(props.abroadInsuranceUrl, props.context) }}>
              למידע ועדכון הפוליסה
            </button>
          </div>
        </>
        )}
      </div>
      <ArrowCircle />
    </div>
  );
};

export const RefundItemExpanded = (props) => {
  let itemText = text.body.refund[props.refundStatus];
  let amount = props.amount;
  let subTitleVal;
  let isOpen = props.currOpenItem === props.id;
  if (amount === null) {
    subTitleVal = itemText.subTitle.value;
  } else {
    if (itemText.subTitleWithAmount.value === '') {
      subTitleVal = itemText.subTitle.value;
    } else {
      subTitleVal = itemText.subTitleWithAmount.value;
    }
  }

  return (
    <div
      className={isOpen ? 'tracker-item-expanded tracker-item-expanded-open' : 'tracker-item-expanded'}
      onClick={() => props.handleItemState(props.id)}>
      <div className='tracker-title-and-subtitle'>
        <div className='item-expanded-title'>{itemText.title.value}</div>
        {isOpen && (
          <div className='tracker-subtitle'>
            {replaceVariablesInBrackets(subTitleVal, props.requestDate, amount, props.dueDate)
              .split('\n')
              .map((str, i) => (
                <p key={i}>{str}</p>
              ))}
          </div>
        )}
      </div>
      <ArrowCircle isOpen={isOpen} />
    </div>
  );
};

export const FollowUpRefundItemExpanded = (props) => {
  let itemText = text.body.followUpRefund[props.refundStatus];
  let subTitleVal;
  let date = props.dueDate;
  let isOpen = props.currOpenItem === props.id;
  if (props.amount !== null) {
    subTitleVal = itemText?.text?.textWithAmount?.value;
  } else {
    subTitleVal = itemText?.text?.textNoAmount?.value;
  }

  return (
    <div
      className={isOpen ? 'tracker-item-expanded tracker-item-expanded-open' : 'tracker-item-expanded'}
      onClick={() => props.handleItemState(props.id)}>
      <div className='tracker-title-and-subtitle'>
        <div className='item-expanded-title'>{itemText.title.value}</div>
        {isOpen && <div className='tracker-subtitle'>
          {replaceVariablesInBrackets(subTitleVal, props.requestDate, props.amount, props.dueDate)
            .split('\n')
            .map((str, i) => <p key={i}>{str}</p>)}
        </div>}
      </div>
      <ArrowCircle isOpen={isOpen} />
    </div>
  );
};

export const PlanChangeItemExpanded = (props) => {
  console.log(props)
  let itemText = text.body.changePricePlan[props.planChangeType];
  var subscriber = props.cellularSubscriber
  let date = props.dueDate === undefined ? '' : props.dueDate;
  let phone = props.cellularNo === undefined ? '' : props.cellularNo;
  let isOpen = props.currOpenItem === props.id;

  const handleButtonClick = (event) => {
    event.stopPropagation();
    props.handleCloseTracker();
    const selectedSubscriber = props.cellularSubscribers.filter(sub => sub.productSubscriberNo === props.cellularNo)[0];
    props.setSelectedSubscriber(selectedSubscriber);
    prepareUrl(props.cellularWorldLink, props.context);
  };

  return (
    <div
      className={isOpen ? 'tracker-item-expanded tracker-item-expanded-open' : 'tracker-item-expanded'}
      onClick={() => props.handleItemState(props.id)}>
      <div className='tracker-title-and-subtitle'>
        <div className='item-expanded-title'>{replaceVariablesInBrackets(itemText.title.value, phone)}</div>
        {isOpen && (
          <div className='tracker-subtitle'>
            {replaceVariablesInBrackets(itemText.text.value, date)
              .split('\n')
              .map((str, i) => (
                <p key={i}>{str}</p>
              ))}
            <br/>
            <div className='tracker-popup-actions'>
              <BtnSubmit text={'לפרטים על החבילה'} onclick={handleButtonClick} />
            </div>
          </div>
        )}
      </div>
      <ArrowCircle isOpen={isOpen}/>
    </div>
  );
};

export const CustomerDeliveriesItemExpanded = (props) => {
  let itemText = text.body.customerDeliveries;
  let isOpen = props.currOpenItem === props.id;
  let dayName = getDayOfWeek(props.deliverySlots[0].date);
  const arrivalDayTxt = props?.deliverySlots[0]?.date;
  const arrivalTimeTxt = props?.deliverySlots[0]?.start + '-' + props?.deliverySlots[0]?.end;
  let locationEvent = replaceVariablesInBrackets(itemText.calenderEventLocation.value, props.address);

  let calenderEventDesc = replaceVariablesInBrackets(
    itemText.calenderEventText.value,
    arrivalDayTxt,
    arrivalTimeTxt,
    props.address,
    Config.staticWebSiteUrl + props.URLs.customerDeliveriesLink.value.url
  );
  let actions = {};

  const event = {
    start: props.addToCalendar,
    duration: props.duration,
    title: itemText.calenderEventName.value,
    description: calenderEventDesc,
    location: locationEvent,
    status: 'CONFIRMED',
    busyStatus: 'BUSY',
  };

  actions['addToCalendar'] = {
    val: itemText.actions.addToCalendar.value,
    url: event,
  };

  actions['editVisit'] = {
    val: itemText.actions.editVisit.value,
    url: props.URLs.customerDeliveriesLink.value.url,
  };

  return (
    <div
      className={isOpen ? 'tracker-item-expanded tracker-item-expanded-open' : 'tracker-item-expanded'}
      onClick={() => props.handleItemState(props.id)}>
      <div className='tracker-title-and-subtitle'>
        <div className='item-expanded-title'>{itemText.title.value}</div>
        {!isOpen ? <div className='tracker-subtitle tracker-line-elipsis'>
          {`נגיע אליך ביום ${dayName} ה- ${props.deliverySlots[0].date} בין השעות ${props.deliverySlots[0].start} - ${props.deliverySlots[0].end}`}</div> : <>
          {props.address && (
            <div
              className='tracker-subtitle'>{itemText.addressText.value + ' ' + props.address}
            </div>
          )}
          <div className='tracker-subtitle'>{`יום ${dayName} ה- ${props.deliverySlots[0].date}`}</div>
          <div className='tracker-subtitle'>{`בין השעות ${props.deliverySlots[0].start} - ${props.deliverySlots[0].end}`}</div>
          <div className='tracker-popup-actions'>
            <button className='tracker-popup-action' onClick={() => props.openUrl(actions['addToCalendar'])}>
              צור תזכורת ביומן שלי
            </button>
            <button className='tracker-popup-action' onClick={() => props.openUrl(actions['editVisit'])}>
              עדכון מועד שליחות
            </button>
          </div>
        </>}
      </div>
      <ArrowCircle isOpen={isOpen} />
    </div>
  );
};

export const FinanceIssueItemExpanded = (props) => {
  const ArrowCircle = (props) => {
    return (
      <div className={`tracker-more-info tracker-more-info-finance-issue tracker-more-info-${props.issueType.toLowerCase()}`}>
        <span
          onClick={
            props.issueType === 'DebtIssue'
              ? () => navigateToDebtIssuePage(props.issueType)
              : () => navigateToPaymentMethodPage(props.issueType)
          }>
          {props.text}
        </span>
      </div>
    );
  };
  const financeIssueType = props.banFinanceIssueType;
  let displayIssueText = '';
  let displayIssueSubText = '';
  let referenceLinks = null;

  const ShowLinks = (issueType) => {
    if (issueType == 'NoPaymentMethodAndDebtIssue') {
      return (
        <div className='d-flex'>
          <ArrowCircle text={'עדכון אמצעי תשלום'} issueType={'NoPaymentMethod'} />
          <ArrowCircle text={'תשלום החוב'} issueType={'DebtIssue'} />
        </div>
      );
    }
    if (issueType == 'DebtIssue') {
      return <ArrowCircle text={'תשלום החוב'} issueType={issueType} />;
    }
    if (issueType == 'NoPaymentMethod') {
      return <ArrowCircle text={'עדכון אמצעי תשלום'} issueType={issueType} />;
    }
  };

  const navigateToPaymentMethodPage = (issueTypeClicked) => {
    let linkTypeClicked = issueTypeClicked.substring(0, 15);
    insertClickToReport(linkTypeClicked);
    props.handleActionClick(props?.URLs?.paymentMethodIssue?.value?.url);
  };

  const navigateToDebtIssuePage = (issueTypeClicked) => {
    let linkTypeClicked = issueTypeClicked.substring(18);
    insertClickToReport(linkTypeClicked);
    props.handleActionClick(props?.URLs?.debtIssue?.value?.url);
  };

  if (financeIssueType === 'NoPaymentMethodAndDebtIssue') {
    displayIssueText = props?.URLs?.debtIssueAndUpdatePaymentMethodText?.value;
    displayIssueSubText = props?.URLs?.debtIssueAndUpdatePaymentMethodSubText?.value;
    referenceLinks = ShowLinks(financeIssueType);
  } else if (financeIssueType === 'NoPaymentMethod') {
    displayIssueText = props?.URLs?.updatePaymentMethodText?.value;
    displayIssueSubText = props?.URLs?.updatePaymentMethodSubText?.value;
    referenceLinks = ShowLinks(financeIssueType);
  } else {
    displayIssueText = props?.URLs?.debtIssueText?.value;
    displayIssueSubText = props?.URLs?.debtIssueSubText?.value;
    referenceLinks = ShowLinks(financeIssueType);
  }
  return (
    <div className='tracker-item-expanded item-finance-issue'>
      <div className='item-finance-issue-content'>
        <Image src={exclamation_mark_gif} className='exclamation-mark'/>
        <div>
          <div className='tracker-title-and-subtitle'>
            <div className='item-expanded-title'>{displayIssueText}</div>
            <div className='tracker-subtitle'>{displayIssueSubText}</div>
          </div>
          {referenceLinks}
        </div>
      </div>
    </div>
  );
};

export const CouponReceivedItemExpanded = (props) => {
  let isOpen = props.currOpenItem === props.id;

  const navigateToCouponHistory = () => {
    props.handleCloseTracker();
    navigateToUrl(props.couponHistoryUrl)
  }

  return (
    <div
      className={isOpen ? 'tracker-item-expanded tracker-item-expanded-open coupon-tracker-item' : 'tracker-item-expanded  coupon-tracker-item'}
      onClick={() => props.handleItemState(props.id)}>
      <div className={'coupon-image-container'}>
        <Image src={couponImage} className='coupon-image'/>
      </div>
      <div className='tracker-title-and-subtitle'>
        <div className='item-expanded-title'>קופון חדש מחכה באזור 'הקופונים שלי'</div>
        <div className='tracker-subtitle'>
          {isOpen ? (
            <>
              <div className={isOpen ? 'description' : 'tracker-line-elipsis'}>
                בתוקף עד ה - {props.expiryDate}
                <br/>
                <span dangerouslySetInnerHTML={{ __html: props.description }}></span>
                <span className={'bold'}>מס׳ קופון </span>{props.couponId}
              </div>
              <div className='tracker-popup-actions'>
                <button className='tracker-popup-action coupon-action-button' onClick={navigateToCouponHistory}>
                  לצפייה בקופונים שלי
                </button>
              </div>
            </>
          ) :
          <span> בתוקף עד ה - {props.expiryDate}</span>}
        </div>
      </div>
      <ArrowCircle isOpen={isOpen}/>
    </div>
  );
};

